module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [(_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-facebook btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" Sign in using Facebook\n\t          ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2da9d5ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 165
// module chunks = 2